var Vue = require("vue");
var VueRouter = require("vue-router");

Vue.use(VueRouter);

var App = require("./App.vue");
var Candidates = require('./components/Candidates.vue');
var Issues = require('./components/Issues.vue');
var CandidateDetails = require('./components/CandidateDetails.vue');
var IssueDetails = require('./components/IssueDetails.vue');

const router = new VueRouter({
  routes: [
      { path: '/', component: App,
        redirect: {
          name: 'candidates'
        },
        children: [
          { path: 'candidates', name: 'candidates', component: Candidates,
            children: [
              { path: ':candidate_slug', component: CandidateDetails, props: true }
            ]},
          { path: 'issues', name: 'issues', component: Issues,
            children: [
              { path: ':issue_slug', component: IssueDetails, props: true }
            ]}
        ]
      }
  ],
  scrollBehavior (to, from, savedPosition) {
  if (to.hash) {
    return {
      selector: to.hash,
      offset: { x: 0, y: 80 }
    }
  }
}
})

new Vue({ router }).$mount('#app')
